import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconEmail2"><Path d="M4.75 4C3.23122 4 2 5.23122 2 6.75V6.78938L11.4381 11.5384C11.7916 11.7163 12.2084 11.7163 12.5618 11.5384L22 6.78938V6.75C22 5.23122 20.7688 4 19.25 4H4.75Z" fill="currentColor"/><Path d="M22 8.46857L13.2361 12.8784C12.4585 13.2696 11.5415 13.2696 10.7639 12.8784L2 8.46857V17.25C2 18.7688 3.23122 20 4.75 20H19.25C20.7688 20 22 18.7688 22 17.25V8.46857Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2;
